import { useEffect, useRef } from 'react';

import { resolveAdminChecksView } from 'helpers/admin-candidate-checks';

import { useTableContext } from 'components/Table/Table';

export const AdminChecksViewSync = ({ onViewChange }) => {
  const { queryParams, setSorting } = useTableContext();
  const view = resolveAdminChecksView(queryParams?.view?.value);
  const prevView = useRef(view);

  useEffect(() => {
    onViewChange?.(view);
  }, [view, onViewChange]);

  useEffect(() => {
    if (prevView.current === view) return;
    prevView.current = view;
    setSorting([]);
  }, [view, setSorting]);

  return null;
};
